export { default } from './CrownDiamond'
